import {
  getComedianByIDOrThrow,
  getComedianBySlugOr404,
} from "../../legacy/comedian";
import { getSpecialByID, getSpecialLite } from "../../legacy/specials";

import { CacheEntities } from "@punchup/utils/caches/cache-types";
import { generateCacheKey } from "@punchup/utils/caches";
import { revalidatePathClient } from "@punchup/utils/vercel";

/**
 * Clears cache for a comedian given their id
 */
export async function CLIENT_clearComedianCachesUsingId(comedianId: string) {
  const comedian = await getComedianByIDOrThrow(comedianId);
  const cacheKeyId = generateCacheKey(CacheEntities.COMEDIAN, comedianId);
  const cacheKeySlug = generateCacheKey(CacheEntities.COMEDIAN, comedian.slug);
  await Promise.all([
    fetch("/api/v2/invalidate-cache", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ key: cacheKeyId }),
    }),
    fetch("/api/v2/invalidate-cache", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ key: cacheKeySlug }),
    }),
    revalidatePathClient(`/${comedian.slug}`),
    revalidatePathClient(`/api/published-comedians`),
  ]);
}

/**
 * Clears cache for a comedian given their slug
 */
export async function CLIENT_clearComedianCachesUsingSlug(slug: string) {
  const comedian = await getComedianBySlugOr404(slug);
  const cacheKeySlug = generateCacheKey(CacheEntities.COMEDIAN, slug);
  const cacheKeyId = generateCacheKey(CacheEntities.COMEDIAN, comedian.id);
  await Promise.all([
    fetch("/api/v2/invalidate-cache", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ key: cacheKeySlug }),
    }),
    fetch("/api/v2/invalidate-cache", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ key: cacheKeyId }),
    }),
    revalidatePathClient(`/${slug}`),
    revalidatePathClient(`/api/published-comedians`),
  ]);
}

/**
 * Client Only: clears caches for a special given the id
 */
export async function CLIENT_clearSpecialCacheUsingId(specialId: string) {
  const special = await getSpecialByID(specialId);
  const comedian = await getComedianByIDOrThrow(special.comedian_id);
  const cacheKeyId = generateCacheKey(CacheEntities.SPECIAL, specialId);
  const cacheKeySlug = generateCacheKey(CacheEntities.SPECIAL, special.slug);
  await Promise.all([
    fetch("/api/v2/invalidate-cache", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ key: cacheKeyId }),
    }),
    fetch("/api/v2/invalidate-cache", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ key: cacheKeySlug }),
    }),
    revalidatePathClient(`/${comedian.slug}/${special.slug}`),
    revalidatePathClient(`/api/published-specials`),
  ]);
}

/**
 * Client Only: clears caches for a special given the slug
 */
export async function CLIENT_clearSpecialCacheUsingSlug(specialSlug: string) {
  const special = await getSpecialLite(specialSlug);
  const comedian = await getComedianByIDOrThrow(special.comedian_id);
  const cacheKeyId = generateCacheKey(CacheEntities.SPECIAL, special.id);
  const cacheKeySlug = generateCacheKey(CacheEntities.SPECIAL, specialSlug);
  await Promise.all([
    fetch("/api/v2/invalidate-cache", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ key: cacheKeySlug }),
    }),
    fetch("/api/v2/invalidate-cache", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ key: cacheKeyId }),
    }),
    revalidatePathClient(`/${comedian.slug}/${specialSlug}`),
    revalidatePathClient(`/api/published-specials`),
  ]);
}
